module.exports = __webpack_public_path__ + "04adcd15fe2fbf29e2f30543f5efea32.svg";